export default __webpack_public_path__ + "static/media/log-ai.a0c6fb08.png";